module.exports = __webpack_public_path__ + "img/var_03_step1@2x.ef57791c.jpg";